import { Component, OnInit } from '@angular/core';
import { GeneralConfigService } from '@inera/common';

@Component({
  standalone: false,
  selector: 'loggedout',
  templateUrl: './loggedout.component.html',
  styleUrls: ['./loggedout.component.scss']
})
export class LoggedoutComponent implements OnInit {
  constructor(private generalConfigService: GeneralConfigService) {}

  ngOnInit(): void {
    this.generalConfigService.getConfig().subscribe();
  }

  public redirect(): void {
    window.location.href = window.location.origin;
  }
}
